<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="10" lg="8">
        <b-card >
          <div slot="header">Kelompok Iklan Baris
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" @row-clicked="rowClicked"
          >
            <template v-slot:cell(nomor)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="4">
              <div>
                Showing
                {{(tblData.page - 1) * tblData.limit + 1}}
                to
                {{tblData.page * tblData.limit}}
                of
                {{tblData.total}}
                entries
              </div>
            </b-col>
            <b-col cols="4" >
                <b-form-group label-cols=4 label="Limit per page" class="mb-0">
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
                </b-form-group>
            </b-col>        
            <b-col cols="4">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Kelompok Iklan Baris - Add/Edit Form 
          </div>
              <b-form-group  label-cols=3  label="Nama Kelompok" >
                  <b-form-input v-model="frmdata.kelompokib" :state="!$v.frmdata.kelompokib.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Display Seq.#" >
                    <b-input-group>
                      <b-form-input v-model="frmdata.nourut" :state="!$v.frmdata.nourut.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">Nomor Urut Penampilan</span></b-input-group-prepend>
                    </b-input-group>
              </b-form-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </b-card>
        </b-col>
    </b-row>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true" :lazy="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        kelompokib: { required },
        iklan: { required },
        nourut: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCrewShow:false,
      frmdata:{nourut: '',kelompokib: '', iklan:0 },
      tblData: {
        tablename:'klpiklanbaris',
        page: 1,
        limit: 20,
        total: 0,
        
        sortBy: null,
        sortDesc: false, 
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "kelompokib",
            label: "Nama Kelompok",
            sortable: true
          },
          {
            key: "nourut",
            label: "Display Seq#",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:100px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.nourut= '';
        this.tblData.kelompokib=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.frmdata.nourut=1;        
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.kodelama = data.kelompokid;
      let _selected;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          this.frmdata.iklan=this.frmdata.iklan||'0';
          this.frmdata.nourut=this.frmdata.nourut||'0';
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.kodelama) {
                await crud.update({tablename:'klpiklanbaris', key:this.frmdata.kodelama, data:{kelompokid:this.frmdata.kelompokid,kelompokib:this.frmdata.kelompokib, nourut: this.frmdata.nourut, crewkey: this.frmdata.crewkey}});
              } else {
                await crud.insert({tablename:'klpiklanbaris', data:{kelompokid:this.frmdata.kelompokid,kelompokib:this.frmdata.kelompokib, nourut: this.frmdata.nourut, crewkey: this.frmdata.crewkey}});
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'klpiklanbaris', key:this.model.kelompokid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({name: "iklankoran.home"});
    },    
  }
};
</script>
